import {useSelector} from 'react-redux'
import InputForm from '../InputFormV2'
import {State} from '../../../../reducers'
import {esNormativaV2, fusionDeLaEmpresa} from '../../../../utils/normativa.utils'

export default function CampoFusion() {
  const {datosEmisor} = useSelector((state: State) => state.catalogos)

  if (!esNormativaV2(datosEmisor)) return null

  const fusion = fusionDeLaEmpresa(datosEmisor)

  return (
    <InputForm
      disabled
      name='fusion'
      label='Fusión (NIT o DUI)'
      type='text'
      placeholder='Sin fusión registrada'
      value={fusion}
      maxLength={14}
      helperText={
        fusion
          ? 'Este valor viene de los datos de su empresa y se envía a Hacienda en el documento.'
          : 'Su empresa no tiene fusión registrada, así que el documento se envía sin este dato. Si le corresponde declararla, solicite que se registre en los datos de la empresa.'
      }
      onChange={() => {}}
    />
  )
}
